export enum TopicExplorerType {
  EXPLORER = 'Explorer',
  BREAKDOWN = 'Breakdown',
}

export enum UnpackType {
  TOPIC = 'Topic',
} 